export default __webpack_public_path__ + "static/promo-balance-transfer-a38b9bb8da03bb5a1ebbd7b3218dfaa5.webp";